import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import { FormControl, Grid, Menu, MenuItem, Select } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import SvgList from '../../components/SvgList';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import DropDownIconSvg from '../../components/Svgs/DropdownIcon.svg';
import Popup from '../../components/Popup';
import SearchBox from '../../components/SearchBox';
import Dropdown from '../../components/Dropdown';
import { set, size } from 'lodash';
import Button from '../../components/Button';
import { SONGS } from '../../constants';
import { userActions } from '../../actions';
import { _showAlert } from '../../utils';

const UserVersionTwo = () => {
  const LIMIT = 50;
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const history = useHistory();
  const options = ['Unlimited', 'Radio'];
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const open = Boolean(anchorEl);
  const [value, setValue] = React.useState('waiting_for_approval');
  const [rowData, setRowData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [userFilterStatus, setUserFilterStatus] = useState({ label: 'All', value: 'ALL' });
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletePopup, setDeletePopup] = useState({
    isOpen: false,
    id: null,
  });

  const [blockPopup, setBlockPopup] = useState({
    isOpen: false,
    id: null,
  });

  const [unblockPopup, setUnblockPopup] = useState({
    isOpen: false,
    id: null,
  });

  function getDaysLeft(timestamp) {
    const currentTime = Date.now(); // Get current time in milliseconds
    const futureTime = timestamp; // Provided timestamp in milliseconds

    // Calculate the difference in milliseconds between future and current time
    const timeDiff = futureTime - currentTime;

    // Convert milliseconds to days
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    const daysLeft = Math.floor(timeDiff / millisecondsInADay);

    if (daysLeft < 0) {
      return 0;
    }

    return daysLeft;
  }

  const fetchMoreUsers = async () => {
    if (isFetchingMore || currentPage.isLast) return;
    const filterToPass = userFilterStatus?.value === 'ALL' ? ['BLOCKED', 'ACTIVE'] : [userFilterStatus?.value];
    setIsFetchingMore(true);

    try {
      const usersFromBE = await userActions.fetchAllUsers({
        page: currentPage.page,
        limit: LIMIT,
        search: searchInput,
        status: filterToPass,
      });
      setUsersData((prev) => [...prev, ...usersFromBE?.data]);
      setIsFetchingMore(false);
      setCurrentPage((prev) => ({ page: prev.page + 1, isLast: size(usersFromBE?.data) < LIMIT }));
    } catch (error) {
      console.error('Error fetching more users:', error);
      setIsFetchingMore(false);
    }
  };

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

    if (bottom && !currentPage.isLast) {
      fetchMoreUsers();
    }
  };

  const handleBlockConfirm = async (id) => {
    setLoading(true);
    try {
      const userresponse = await userActions.updateUser(id, {
        status: 'BLOCKED',
      });

      if (userresponse?.code === 'OK') {
        const updatedUsersData = usersData.map((user) => (user.id === id ? { ...user, status: 'BLOCKED' } : user));
        setUsersData(updatedUsersData);
        _showAlert('User Blocked Successfully', 'success', 4000);
        setBlockPopup({ isOpen: false, id: null });
        setLoading(false);
      }
    } catch (error) {
      console.error('Error blocking user:', error);
    }
  };

  const handleDeleteConfirm = async () => {
    setLoading(true);
    try {
      const userresponse = await userActions.deleteUser(deletePopup?.id);

      if (userresponse?.code === 'OK') {
        const updatedUsersData = usersData.filter((user) => user.id !== deletePopup?.id);
        setUsersData(updatedUsersData);
        setDeletePopup({ isOpen: false, id: null });
        setLoading(false);
      }
    } catch (error) {
      console.error('Error blocking user:', error);
    }
  };

  const handleUnblockConfirm = async (id) => {
    setLoading(true);
    try {
      const userresponse = await userActions.updateUser(id, {
        status: 'ACTIVE',
      });

      if (userresponse.code === 'OK') {
        const updatedUsersData = usersData.map((user) => (user.id === id ? { ...user, status: 'ACTIVE' } : user));
        _showAlert('User Unblocked Successfully', 'success', 4000);
        setUsersData(updatedUsersData);
        setUnblockPopup({ isOpen: false, id: null });
        setLoading(false);
      }
    } catch (error) {
      console.error('Error blocking user:', error);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleMenuItemClick = (event, index) => {
    setAnchorEl(null);
  };

  const calculateDaysLeft = (expiryDate) => {
    const timeDiff = expiryDate - new Date();
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  };

  const handleSearchInputChange = async (searchVal) => {
    setSearchInput(searchVal);
  };

  useEffect(() => {
    (async () => {
      const filterToPass = userFilterStatus?.value === 'ALL' ? ['BLOCKED', 'ACTIVE'] : [userFilterStatus?.value];
      setIsLoading(true);
      try {
        const response = await userActions.fetchAllUsers({
          page: 1,
          limit: LIMIT,
          search: searchInput,
          status: filterToPass,
        });

        setUsersData(response.data);
        setIsLoading(false);
        setCurrentPage((prev) => ({
          page: prev.page + 1,
          isLast: size(response.data) < LIMIT,
        }));
      } catch (error) {
        console.error('Error fetching users:', error);
        setIsLoading(false);
      }
    })();
  }, [searchInput, userFilterStatus]);

  return (
    <>
      <NavBar data="2.0 Users" icon={Settings} currentRouteName="2.0 Users" breadcrumbsPath={[{ name: 'Users' }]} />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ marginBottom: 12, width: '100%' }}>
          <Grid container style={{ justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <SearchBox placeholder="Search User here..." onChange={(e) => handleSearchInputChange(e)} />
              <Dropdown value={userFilterStatus} setValue={setUserFilterStatus} options={SONGS.USERS} />
            </div>
          </Grid>
        </div>

        <div style={{ display: 'flex', height: '100%', overflow: 'hidden', flex: 1, width: '100%' }}>
          <TableContainer className="tbl_wraper tbl_wrap" component={Paper} onScroll={handleScroll}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result">Result</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Business Name</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Plan</TableCell>
                  <TableCell>Plan Status</TableCell>
                  <TableCell style={{ minWidth: 217 }}>User Status</TableCell>
                  <TableCell style={{ minWidth: 100 }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}

                {usersData?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Users Found
                    </h4>
                  </div>
                ) : (
                  usersData?.map((user, index) => (
                    <TableRow
                      key={user.id}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        history.push(`/users/2.0-users/${user.id}`);
                      }}
                    >
                      <TableCell className="result">#{++index}</TableCell>
                      <TableCell>{`${user.first_name} ${user.last_name}`}</TableCell>
                      <TableCell>{user.business_name || ''}</TableCell>
                      <TableCell>{user.phone_no}</TableCell>
                      <TableCell>{user.primium_type}</TableCell>
                      <TableCell>{getDaysLeft(new Date(user?.primium_expiry_date)) + ' days left'}</TableCell>
                      <TableCell style={{ minWidth: 217, display: 'flex' }}>
                        <div className="button-group" style={{ alignItems: 'center' }}>
                          {user.status === 'BLOCKED' ? (
                            <button className="button approve" style={{ color: '#DD4E47', background: '#F7E4E3', alignItems: 'center' }}>
                              {user.status}
                            </button>
                          ) : (
                            <button className="button approve" style={{ color: 'green', background: '#E9F9EF', alignItems: 'center' }}>
                              {user.status}
                            </button>
                          )}

                          <div
                            style={{ cursor: 'pointer' }}
                            className="switch"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (user.status === 'BLOCKED') {
                                setUnblockPopup({ isOpen: true, id: user.id });
                              } else if (user.status === 'ACTIVE') {
                                setBlockPopup({ isOpen: true, id: user.id });
                              }
                            }}
                          >
                            <SvgList name="switch-icon" />
                          </div>
                        </div>
                      </TableCell>
                      <TableCell style={{ minWidth: 100 }}>
                        <div style={{ display: 'flex', columnGap: 15, alignItems: 'center' }}>
                          <div
                            style={{ cursor: 'pointer' }}
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   if (user.status === 'BLOCKED') {
                            //     setUnblockPopup({ isOpen: true, id: user.id });
                            //   } else if (user.status === 'ACTIVE') {
                            //     setBlockPopup({ isOpen: true, id: user.id });
                            //   }
                            // }}
                          >
                            <SvgList name="copylink-icon" />
                          </div>
                          <div
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeletePopup({ isOpen: true, id: user.id });
                            }}
                          >
                            <SvgList name="cancel-icon" />
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}

                {isFetchingMore && (
                  <TableRow className="fetch_more_loader">
                    <CircularProgress />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <Popup open={blockPopup?.isOpen} onClose={() => !loading && setBlockPopup({ isOpen: false, id: null })}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
            Are you sure, you want to block this User?
          </h4>
          <div className="button-group" style={{ '--button-color': '#6900af' }}>
            <Button onClick={() => !loading && setBlockPopup({ isOpen: false, id: null })} className="button transparent">
              Cancel
            </Button>

            <Button isLoading={loading} onClick={() => handleBlockConfirm(blockPopup.id)} className="button primary">
              Confirm
            </Button>
          </div>
        </Popup>

        <Popup open={deletePopup?.isOpen} onClose={() => !loading && setDeletePopup({ isOpen: false, id: null })}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
            Are you sure, you want to delete this User
          </h4>
          <div className="button-group" style={{ '--button-color': '#6900af' }}>
            <Button onClick={() => !loading && setDeletePopup({ isOpen: false, id: null })} className="button transparent">
              Cancel
            </Button>

            <Button isLoading={loading} onClick={handleDeleteConfirm} className="button primary">
              Confirm
            </Button>
          </div>
        </Popup>

        <Popup open={unblockPopup?.isOpen} onClose={() => !loading && setUnblockPopup({ isOpen: false, id: null })}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
            Are you sure, you want to unblock this user?
          </h4>
          <div className="button-group" style={{ '--button-color': '#6900af' }}>
            <Button onClick={() => !loading && setUnblockPopup({ isOpen: false, id: null })} className="button transparent">
              Cancel
            </Button>

            <Button isLoading={loading} onClick={() => handleUnblockConfirm(unblockPopup.id)} className="button primary">
              Confirm
            </Button>
          </div>
        </Popup>
      </div>
    </>
  );
};

export default UserVersionTwo;

